import { SEARCH_CHANGE } from '../TopBar/constants'

import { TOGGLE_COMMUNICATION_WIDGET } from './constants'

export default function () {
  const initialState = {
    isOpenCommunicationWidget: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_CHANGE:
        return {
          ...state,
          isOpenCommunicationWidget: false,
        }
      case TOGGLE_COMMUNICATION_WIDGET:
        return {
          ...state,
          isOpenCommunicationWidget: !state.isOpenCommunicationWidget,
        }
      default:
        return state
    }
  }
}
